"use client";
import { cn } from "@pulsex/utils";
import { useState } from "react";
import "@/styles/carousel-base.css";
import TabulatedSideNews from "../NewsPage/TabulatedSideNews";
// export const runtime = "edge"; // 'nodejs' (default) | 'edge

//? The Breaking news and most read

export default function SideBarTabs({ widget }: any) {
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    return (
        <div className="bg-gray-100 dark:text-white dark:bg-bgblue p-2 rounded h-full min-h-[900px] max-h-[900px] overflow-hidden">
            <div className="flex justify-center items-center gap-4 px-5 border-b border-gray-300">
                {widget?.map((item: any, index: any) => (
                    <div
                        key={index}
                        onClick={() => setActiveTabIndex(index)}
                        className={cn(
                            "text-sm border-b-[3px] cursor-pointer border-transparent font-bold text-center px-2 py-2",
                            activeTabIndex === index && "border-primary"
                        )}
                    >
                        {item.title}
                    </div>
                ))}
            </div>
            {widget?.map(
                (item: any, index: any) =>
                    activeTabIndex === index && (
                        <TabulatedSideNews widget={item} key={index} />
                    )
            )}
        </div>
    );
}
